import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { ClassWebsite } from "@shared/models/class-website"
import FindDocument from "cc-frontend/helpers/find-doc"
import type EmberStore from "cc-frontend/services/ember-store"
import { use } from "ember-could-get-used-to-this"

export interface Signature {
  Args: {
    classWebsiteId: string
  }
  Blocks: {
    default: [model: FindDocument<"class-website", ClassWebsite>]
  }
}

export default class ClassWebsiteSettingsProvider extends Component<Signature> {
  @service("ember-store") declare store: EmberStore

  @use model = new FindDocument(() => ["class-website", this.args.classWebsiteId])
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    ClassWebsiteSettingsProvider: typeof ClassWebsiteSettingsProvider
  }
}
